<template>
  <div id="login-subview">
    <h5 style="padding-bottom: 1rem;">{{$t('sign-in:recover-password__title')}}</h5>
    <p>{{$t('sign-in:recover-password__body')}}</p>
    <b-form class="justify-content-center" @submit.prevent="recover" v-if="!recoverDone">
      <b-form-group>
        <b-input v-model="email" class="mb-2 mr-sm-2 mb-sm-0" id="email-login__email" type="email" :placeholder="$t('common:email')"/>
      </b-form-group>
      <b-button type="submit" variant="primary" :disabled="!email">{{$t('sign-in:recover-password__button')}}</b-button>
    </b-form>
    <b-alert variant="success" :show="recoverDone"><span v-html="$t('sign-in:recover-password__in-progress')"></span></b-alert>
    <br/>
    <router-link to="login">{{$t('sign-in:recover-password__sign-in-link')}}</router-link>
  </div>
</template>

<script>

export default {
  data () {
    return {
      email: null,
      recoverDone: false,
      recoverError: false
    }
  },
  methods: {
    recover: function () {
      this.recoverDone = false
      this.recoverError = false
      this.axios.get('/auth/recover/' + this.email).then((response) => {
        this.recoverDone = true
      }).catch(() => {
        this.recoverError = true
      })
    }
  }
}
</script>
